import Vue from 'vue'
import Router from 'vue-router'

const Index = () => import('../page/index.vue')
const Login = () => import('../page/Login/login.vue')
const Forgot = () => import('../page/Login/forgot.vue')
const Register = () => import('../page/Login/register.vue')
const Home = () => import('../page/Home/home.vue')
const GoodS = () => import('../page/Goods/goods.vue')
const goodsDetails = () => import('../page/Goods/goodsDetails.vue')
const Cart = () => import('../page/Cart/cart.vue')
const order = () => import('../page/Order/order.vue')
const user = () => import('../page/User/user.vue')
const orderList = () => import('../page/User/children/order.vue')
const ckdList = () => import('../page/User/children/ckd.vue')
const information = () => import('../page/User/children/information.vue')
const addressList = () => import('../page/User/children/addressList.vue')

const checkout = () => import('../page/Checkout/checkout.vue')
const payment = () => import('../page/Order/payment.vue')
// const paysuccess = () => import('../page/Order/paysuccess.vue')
// const Thanks = () => import('../page/Thanks/thanks.vue')
const Search = () => import('../page/Search/search.vue')
const Articles = () => import('../page/Articles/articles.vue')
const RefreshSearch = () => import('../page/Refresh/refreshsearch.vue')
const RefreshGoods = () => import('../page/Refresh/refreshgoods.vue')
const RefreshLb = () => import('../page/Refresh/refreshlb.vue')
const orderDetail = () => import('../page/User/children/orderDetail.vue')
const ckdDetail = () => import('../page/User/children/ckdDetail.vue')
// const Alipay = () => import('../page/Order/alipay.vue')
// const Wechat = () => import('../page/Order/wechat.vue')
// const QQpay = () => import('../page/Order/qqpay.vue')
const ECS = () => import('../ecs_page/containers/KlContainer.vue')
const ecsArap = () => import('../ecs_page/arap.vue')
const ecsCkdDetail = () => import('../ecs_page/ckdDetail.vue')
const ecsCkdList = () => import('../ecs_page/ckdList.vue')
const ecsCkdManage = () => import('../ecs_page/ckdManage.vue')
const ecsFkdDetail = () => import('../ecs_page/fkdDetail.vue')
const ecsFkdList = () => import('../ecs_page/fkdList.vue')
const ecsCkdKpList = () => import('../ecs_page/ckdKpList.vue')
const ecsWldzList = () => import('../ecs_page/wldzList.vue')
const ecsCkdCpList = () => import('../ecs_page/ckdCpList.vue')
const ecsCkcpxlhList = () => import('../ecs_page/ckcpxlhList.vue')
const ecsXsfkList = () => import('../ecs_page/xsfkList.vue')
const ecsGoodsList = () => import('../ecs_page/goodsList.vue')
const ecsOrderList = () => import('../ecs_page/orderList.vue')
const ecsOrderDetail = () => import('../ecs_page/orderDetail.vue')
const ecsOrderEdit = () => import('../ecs_page/orderEdit.vue')
const ecsCkdEdit = () => import('../ecs_page/ckdEdit.vue')

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/home',
      children: [
        {path: 'home', meta: {title: ' '}, component: Home},
        {path: 'goods', meta: {title: '商品列表 - '}, component: GoodS},
        {path: 'search', meta: {title: '商品搜索 - '}, component: Search},
        {path: 'articles', meta: {title: ''}, component: Articles},
        {path: 'goodsDetails', meta: {title: '商品详情 - '}, name: 'goodsDetails', component: goodsDetails},
        // {path: 'thanks', name: 'thanks', component: Thanks},
        {path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods},
        {path: '/refreshlb', name: 'refreshlb', component: RefreshLb}
      ]
    },
    {path: '/login', meta: {title: '登录'}, name: 'login', component: Login},
    {path: '/register', meta: {title: '注册'}, name: 'register', component: Register},
    {path: '/forgot', meta: {title: '找回密码'}, name: 'forgot', component: Forgot},
    {path: '/cart', meta: {title: '购物车'}, name: 'cart', component: Cart},
    {path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch},
    {
      path: '/order',
      name: 'order',
      component: order,
      children: [
        // {path: 'paysuccess', name: 'paysuccess', component: paysuccess},
        {path: 'payment', meta: {title: '订单支付'}, name: 'payment', component: payment}
        // {path: 'alipay', name: 'alipay', component: Alipay},
        // {path: 'wechat', name: 'wechat', component: Wechat},
        // {path: 'qqpay', name: 'qqpay', component: QQpay}
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      redirect: '/user/orderList',
      children: [
        {path: 'orderList', meta: {title: '订单列表'}, name: 'orderList', component: orderList},
        {path: 'ckdList', meta: {title: '出库单列表'}, name: 'ckdList', component: ckdList},
        {path: 'orderDetail', meta: {title: '订单详情'}, name: 'orderDetail', component: orderDetail},
        {path: 'ckdDetail', meta: {title: '订单详情'}, name: 'ckdDetail', component: ckdDetail},
        {path: 'information', meta: {title: '账户资料'}, name: 'information', component: information},
        {path: 'addressList', meta: {title: '收货地址'}, name: 'addressList', component: addressList}
      ]
    },
    {path: '/checkout', meta: {title: '商品结算'}, name: 'checkout', component: checkout},
    {path: '*', redirect: '/home'},
    {
      path: '/ecs',
      component: ECS,
      name: 'ecs',
      children: [
        {path: 'arap', meta: {title: '应收应付'}, name: 'ecs_arap', component: ecsArap},
        {path: 'ckdList', meta: {title: '出库单查询'}, name: 'ecs_ckdList', component: ecsCkdList},
        {path: 'ckdManage', meta: {title: '出库单管理'}, name: 'ecs_ckdManage', component: ecsCkdManage},
        {path: 'ckdDetail', meta: {title: '出库单详情'}, name: 'ecs_ckdDetail', component: ecsCkdDetail},
        {path: 'fkdList', meta: {title: '付款单查询'}, name: 'ecs_fkdList', component: ecsFkdList},
        {path: 'fkdDetail', meta: {title: '付款单详情'}, name: 'ecs_fkdDetail', component: ecsFkdDetail},
        {path: 'ckdKpList', meta: {title: '出库单开票查询'}, name: 'ecs_ckdKpList', component: ecsCkdKpList},
        {path: 'wldzList', meta: {title: '往来对账查询'}, name: 'ecs_wldzList', component: ecsWldzList},
        {path: 'ckdCpList', meta: {title: '出库产品查询'}, name: 'ecs_ckdCpList', component: ecsCkdCpList},
        {path: 'ckcpxlhList', meta: {title: '出库产品系列号查询'}, name: 'ecs_ckcpxlhList', component: ecsCkcpxlhList},
        {path: 'xsfkList', meta: {title: '销售付款查询'}, name: 'ecs_xsfkList', component: ecsXsfkList},
        {path: 'goodsList', meta: {title: '库存报价'}, name: 'ecs_goodsList', component: ecsGoodsList},
        {path: 'orderList', meta: {title: '订单查询'}, name: 'ecs_orderList', component: ecsOrderList},
        {path: 'orderDetail', meta: {title: '订单查询'}, name: 'ecs_orderDetail', component: ecsOrderDetail},
        {path: 'ckdEdit', meta: {title: '出库开单'}, name: 'ecs_ckdEdit', component: ecsCkdEdit},
        {path: 'orderEdit', meta: {title: '订单开单'}, name: 'ecs_orderEdit', component: ecsOrderEdit}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js